import { useUI } from 'hooks/index';
import cn from 'classnames';
import Icon from 'components/shared/icon';
import getFormattedDate from 'lib/utils/getFormattedDate';
import getFormattedStatus from 'lib/utils/getFormattedStatus';
import { useRouter } from 'next/router';
import OrderLineItem from './lineItem';
import styles from '../salonAccount.module.scss';

const Drawer = ({ order, global }) => {
  const { locale } = useRouter();
  const { displayDrawer, toggleDrawer } = useUI();

  return (
    <div className={cn(styles.drawer, { [styles.active]: displayDrawer })}>
      <div
        className={cn(styles.overlay, { [styles.on]: displayDrawer })}
        onClick={toggleDrawer}
        onKeyDown={toggleDrawer}
        role="button"
        tabIndex="0"
        alt="overlay"
      />
      <div className={cn(styles.content, { [styles.open]: displayDrawer })}>
        <div
          className={styles.close}
          onClick={toggleDrawer}
          onKeyDown={toggleDrawer}
          role="button"
          tabIndex="0"
        >
          <Icon type="close" />
        </div>
        <div className={styles.contentInfo}>
          <div className={styles.amountAndStatus}>
            <div className={styles.amount}>{order?.amount}</div>
            <div className={styles.status}>
              {getFormattedStatus(
                order?.status.toLowerCase(),
                global?.orders['ordersTable-Paid']?.text,
                global?.orders['ordersTable-Payable']?.text,
                global?.orders['ordersTable-AwaitingReturnPeriod']?.text,
                global?.orders['ordersTable-Expired']?.text
              )}
            </div>
          </div>
          <div className={styles.orderInfo}>
            <div className={styles.infoItem}>
              <div className={styles.itemTitle}>{global?.tables['tables-Total']?.text}</div>
              <div className={styles.itemValue}>{order?.kickbackfee}</div>
            </div>
            <div className={styles.infoItem}>
              <div className={styles.itemTitle}>{`${global?.tables['tables-Order']?.text} #`}</div>
              <div className={styles.itemValue}>{order?.orderNo}</div>
            </div>
            <div className={styles.infoItem}>
              <div className={styles.itemTitle}>{global?.tables['tables-Date']?.text}</div>
              <div className={styles.itemValue}>{getFormattedDate(order?.date, 'ISO')}</div>
            </div>
          </div>
        </div>
        <div className={styles.contentLineItems}>
          {order?.lineItems?.map(item => (
            <OrderLineItem item={item} key={item.id} locale={locale} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
